import { T, useGT } from 'gt-react';
import {
  MagnifyingGlassMinusIcon,
  MagnifyingGlassPlusIcon,
} from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { ZoomState } from './useZoom';

/** Zoom out · current percentage (click to reset) · zoom in. */
export function ZoomControls({ state }: { state: ZoomState }) {
  const gt = useGT();
  return (
    <div className="flex items-center">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className="h-8 px-2"
            onClick={state.zoomOut}
            disabled={!state.canZoomOut}
            aria-label={gt('Zoom out', { context: 'xlsx viewer zoom' })}
          >
            <MagnifyingGlassMinusIcon className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <T context="xlsx viewer zoom tooltip">Zoom out</T>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={state.resetZoom}
            className="min-w-[3rem] px-1 text-xs tabular-nums text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded"
            aria-label={gt('Reset zoom to 100%', {
              context: 'xlsx viewer zoom',
            })}
          >
            {gt('{percentage}%', {
              context: 'xlsx viewer zoom percentage',
              percentage: String(Math.round(state.zoom * 100)),
            })}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <T context="xlsx viewer zoom tooltip">Reset zoom to 100%</T>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className="h-8 px-2"
            onClick={state.zoomIn}
            disabled={!state.canZoomIn}
            aria-label={gt('Zoom in', { context: 'xlsx viewer zoom' })}
          >
            <MagnifyingGlassPlusIcon className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <T context="xlsx viewer zoom tooltip">Zoom in</T>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
